var module = angular.module('octopusApp.projects');

module.directive('sampleVersions', function($timeout) {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        scope: {
            testVersion: "&",
            tag: "=",
            versionRange: "=",
            initialData: "="
        },
        template: "<div ui-ace=\"{ mode: 'version', showGutter: false, onLoad: vm.aceLoaded, onChange: vm.aceChanged}\" ng-model=\"vm.versions\" ng-model-options=\"{ debounce: 100 }\"></div>",
        link: function($scope, $element) {
            $scope.$element = $element;
        },
        controller: function($scope) {
            var vm = this;
            var tested = {};
            this.versions = ($scope.initialData && $scope.initialData.length) ? $scope.initialData.join("\n") : "1.0\n1.1.0\n1.1.0-bugfix";

            this.aceLoaded = function(editor){
                editor.setShowPrintMargin(false);
                editor.setHighlightActiveLine(false);
                editor.$blockScrolling = Infinity;
            };

            $scope.$watch(function () { return vm.versions; }, function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    invokeService();
                }
            });
            $scope.$watch(function () {
                return { tag: $scope.tag, versionRange: $scope.versionRange };
            }, function() {
                tested = {};
                invokeService();
            }, true);

            function invokeService() {
                vm.versions.split('\n').forEach(function (version) {
                    if (tested[version]) {
                        reApplyStyles();
                    } else {
                        $scope.testVersion({version: version, done: resultReturned});
                    }
                });
            }

            function reApplyStyles(){
                $.each($scope.$element.find(".ace_line"), function(i, elem) {
                    var $elem = $(elem);
                    var result = tested[$elem.text()];
                    if (result) {
                        setStyle($elem, result);
                    }
                });
            }

            function setStyle($element, result) {
                $element.removeClass("version-invalid")
                        .removeClass("tag-error")
                        .removeClass("tag-ok")
                        .removeClass("range-error")
                        .removeClass("range-ok");

                if (result.Errors.indexOf("Invalid Version Number") !== -1) {
                    $element.addClass("version-invalid");
                } else {
                    if ($element.find('.ace_tag').length === 0 && !result.SatisfiesPreReleaseTag) {
                        $element.addClass("range-error");
                    } else {
                        $element.addClass(result.SatisfiesPreReleaseTag ? "tag-ok" : "tag-error");
                        $element.addClass(result.SatisfiesVersionRange ? "range-ok" : "range-error");
                    }
                }
            }

            function resultReturned(version, result) {
                tested[version] = result;

                $.each($scope.$element.find(".ace_line"), function(i, elem){
                    var $elem = $(elem);
                    if ($elem.text() === version) {
                        setStyle($elem, result);
                    }
                });
            }
        },
        controllerAs: 'vm'
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/channels/sample-versions.js
// module id = 8504097494513817
// module chunks = 1